import { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { authStaff } from "../../../utils/constants";
import { selectAccessToken } from "../../../slices/staffSlice";
import { accessFileRequest } from "../../../Requests/getRequests";
import { show } from '../../../slices/toastSlice';
import { Loader, PhotoModal } from '../../../components';
import { HugeiconsIcon } from '@hugeicons/react';
import { Download01Icon, EyeIcon } from '@hugeicons/core-free-icons';

function SysFile({ file, loanId, phone }) {

    const fileExt = file.split(".").pop();
    const fileExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const [imageSrc, setImageSrc] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [loading, isLoading] = useState(false);

    function closeModal() { setIsOpen(false); }

    const getUrl = async () => {
        isLoading(true);
        try {
            let res = await accessFileRequest(`/loans/staff/getFile`, authStaff(accessToken), {
                loanId, phone, name: file
            });
            if (!res || res.err || !res.data) {
                dispatch(show({ type: "error", state: true, message: res?.err || "Could not open the file." }));
                return;
            }

            const fileUrl = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = fileUrl;
            const disposition = res.headers?.['content-disposition'];
            const fileName = disposition ? disposition.split('filename=')[1].replace(/["']/g, '') : file;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            const extension = fileName.split('.').pop();

            if (fileExtensions.includes(extension)) {
                link.click();
                link.remove();
            } else {
                setImageSrc(fileUrl);
                setIsOpen(!isOpen);
            }
        } finally {
            isLoading(false);
        }
    };

    const isDoc = fileExtensions.includes(fileExt);

    return (
        <tr className="hover:bg-gray-50/50 dark:hover:bg-gray-700/30 transition-colors">
            <td className="px-5 py-3.5 text-sm text-gray-700 dark:text-gray-300">{file}</td>
            <td className="px-5 py-3.5 text-right">
                <div className="inline-flex items-center justify-end gap-2">
                    {loading && <Loader color="text-gray-400" size="w-4 h-4" />}
                    <button
                        type="button"
                        onClick={getUrl}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-[#1e3a6e] dark:text-blue-400 hover:text-[#264d91] dark:hover:text-blue-300 transition-colors"
                    >
                        <HugeiconsIcon icon={isDoc ? Download01Icon : EyeIcon} size={14} />
                        {isDoc ? 'Download' : 'View'}
                    </button>
                </div>
            </td>
            <td className="hidden">
                <PhotoModal imageUrl={imageSrc} isOpen={isOpen} closeModal={closeModal} />
            </td>
        </tr>
    );
}

export default SysFile;
